
if (!console)
{
	// avoid ie|edge bugs
	const console =
		{
			log: function(){},
			debug: function(){},
			info: function(){},
			warn: function(){},
			error: function(){},
		}
}
